module.exports = __webpack_public_path__ + "static/img/11.6f15845.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/11.png
// module id = nLKj
// module chunks = 2